<template>
    <div class="d-flex justify-content-center align-items-center flex-column">
        <input ref="inputFile" type="file" v-show="false" @change="onChange" />
        <CButton size="lg" shape="pill" variant="ghost" @click="click"
            ><CIcon name="cil-cloud-upload" size="lg"
        /></CButton>
        <p class="mb-0">
            {{ fileName }} - {{ totalLines }} {{ totalLines ? "lines" : "" }}
        </p>
    </div>
</template>

<script>
import baseMixin from "@/mixins/base";
import { parseURL } from "../utils";

export default {
    name: "CCButtonUploadFile",
    mixins: [baseMixin],
    data() {
        return {
            componentFile: null,
            firstLine: null,
            totalLines: null,
        };
    },
    computed: {
        fileName() {
            if (!this.componentFile) {
                return null;
            }
            return this.componentFile.name;
        },
    },
    props: {
        label: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: null,
        },
        color: {
            type: String,
            default: null,
        },
        size: {
            type: String,
            default: "md",
        },
        uploadType: {
            required: true,
            type: String,
        },
        uploadKey: {
            type: String,
            default: null,
        },
    },
    watch: {},
    methods: {
        onChange(e) {
            if (e.target.files.length === 0) {
                return;
            }
            this.componentFile = e.target.files[0];

            let r = new FileReader();
            r.onload = this.readFile;
            r.readAsText(this.componentFile);

            r.onloadend = () => {
                this.$emit("change", {
                    file: this.componentFile,
                    firstLine: this.firstLine,
                    totalLines: this.totalLines,
                });
            };
        },

        readFile(e) {
            let contents = e.target.result;
            let lines = contents.split("\n");
            this.firstLine = lines[0];
            this.totalLines = lines.length;
        },
        click() {
            const inputFile = this.$refs["inputFile"];
            inputFile.click();
        },
        reset(){
            this.componentFile = null;
            this.firstLine = null;
            this.totalLines = null;
        },
        async saveFile() {
            if (!this.componentFile) {
                throw new Error("No file selected");
            }
            const { data } = await this.fetcher({
                baseURL: process.env.VUE_APP_API_SASS,
                // baseURL: "http://localhost:3000/prod",
                url: `/imports/get-pre-signed-upload-url`,
                method: "POST",
                data: {
                    fileName: this.componentFile.name,
                    type: this.uploadType,
                    key: this.uploadKey,
                },
            });

            const uploadURL = parseURL(data.url);
            await this.fetcher({
                baseURL: uploadURL.baseURL,
                url: uploadURL.path,
                query: uploadURL.queryParams,
                method: "PUT",
                data: this.componentFile,
            });

            return {
                fileName: data.fileName,
                key: data.key,
            };
        },
    },
    async mounted() {},
};
</script>
